import { extractErrorMessage } from "src/utils/misc";
import client from "../client";
import { buttonLoading, initPage, totalPages, totalRecords, } from "src/store/store";
export async function lockUnlockCar(action, vehicleId, remark) {
    try {
        buttonLoading.set(true);
        const response = await client(`/v1/${action}/${vehicleId}`, {
            method: "POST",
            version: "Vehicle",
            data: {
                remark,
            },
        });
        return response;
    }
    catch (error) {
        console.error(error);
        extractErrorMessage(error);
        throw error;
    }
    finally {
        buttonLoading.set(false);
    }
}
export async function getVehicleDetails(vehicleId) {
    try {
        const response = await client(`/v1/${vehicleId}/details`, {
            method: "GET",
            version: "Vehicle",
        });
        return response;
    }
    catch (error) {
        console.error(error);
        extractErrorMessage(error);
        throw error;
    }
}
export async function getCarActivities(sourceId, source, page) {
    try {
        const response = await client(`/v1/actionLogs/filter`, {
            method: "GET",
            version: "Vehicle",
            params: {
                sourceId,
                source,
                page,
            },
        });
        totalRecords.set(response.data.totalCount);
        totalPages.set(response.data.totalPage);
        initPage.set(response.data.pageNumber);
        return response;
    }
    catch (error) {
        console.error(error);
        extractErrorMessage(error);
        throw error;
    }
}
export async function loadVehicleOptions(inputValue) {
    // only search if input has at least 3 characters
    if (!inputValue || inputValue.trim().length < 3)
        return [];
    try {
        const res = await client(`/v1/plateNumbers/${inputValue}?limit=100`, {
            method: "GET",
            version: "Vehicle",
        });
        return res.data.map((car) => ({
            value: car.vehicleId,
            label: car.plateNo,
        }));
    }
    catch (e) {
        console.error(e);
        return [];
    }
}
export async function getAssetOwner(vehicleId) {
    try {
        const res = await client(`/v1/${vehicleId}/details`, {
            method: "GET",
            version: "Vehicle",
        });
        return res;
    }
    catch (error) {
        console.error(error);
        extractErrorMessage(error);
        throw error;
    }
}
export async function editVehicleModel({ id, name, vehicleTypeID, vehicleMakeID, }) {
    try {
        const res = await client("/v1/models", {
            method: "PUT",
            version: "Vehicle",
            data: {
                name: name,
                vehicleTypeID: vehicleTypeID,
                vehicleMakeID: vehicleMakeID,
                id: id,
            },
        });
        return res;
    }
    catch (error) {
        console.error(error);
        extractErrorMessage(error);
        throw error;
    }
}
export async function addVehicleModel({ name, vehicleTypeID, vehicleMakeID }) {
    try {
        const res = await client("/v1/models", {
            method: "POST",
            version: "Vehicle",
            data: {
                name: name,
                vehicleTypeID: vehicleTypeID,
                vehicleMakeID: vehicleMakeID,
            },
        });
        return res;
    }
    catch (error) {
        console.error(error);
        extractErrorMessage(error);
        throw error;
    }
}
export async function getVehicleModels(initPage) {
    try {
        const res = await client(`/v1/models/filter?Page=${initPage}&Size=50`, {
            method: "GET",
            version: "Vehicle",
        });
        return res;
    }
    catch (error) {
        console.error(error);
        extractErrorMessage(error);
        throw error;
    }
}
export async function deleteVehicleModel(id) {
    try {
        const res = await client(`/v1/models/${id}`, {
            method: "DELETE",
            version: "Vehicle",
        });
        return res;
    }
    catch (error) {
        console.error(error);
        extractErrorMessage(error);
        throw error;
    }
}
export async function changeVehicleModelStatus(id, status) {
    try {
        const res = await client("/v1/models/status", {
            method: "PUT",
            version: "Vehicle",
            data: {
                id,
                status,
            },
        });
        return res;
    }
    catch (error) {
        console.error(error);
        extractErrorMessage(error);
        throw error;
    }
}
